//Please add the language resource
const customerCarrier = {

  msg:{
  }
};
export default customerCarrier



// WEBPACK FOOTER //
// ./src/page/md/customerCarrier/lang/customerCarrier.en.js